/**
 * Links the operator copies and the client opens.
 *
 * The API returns paths (`/s/<token>`, `/pay/<token>`), not URLs: the SPA's origin is
 * deployment configuration, and the screen that shows the link already knows it. This
 * module is the one place that joins the two, so a link is never assembled by hand.
 */

const SAFE_CHECKOUT_PROTOCOLS: ReadonlySet<string> = new Set(["https:", "http:"]);

/** `origin` + `path`, with the origin's trailing slash removed and the path required to be absolute. */
export function absolutePublicUrl(origin: string, path: string): string {
  if (path === "") {
    throw new RangeError("An empty path has no public link to join.");
  }
  if (!path.startsWith("/")) {
    throw new RangeError(`Public path must start with "/": ${path}`);
  }
  return `${origin.replace(/\/+$/, "")}${path}`;
}

/**
 * Whether a checkout address handed back by the API may be navigated to. The gateway
 * address is the one place the page leaves the SPA, so only a web address is followed.
 */
export function isSafeCheckoutUrl(value: string): boolean {
  if (value === "") {
    return false;
  }
  try {
    return SAFE_CHECKOUT_PROTOCOLS.has(new URL(value).protocol);
  } catch {
    return false;
  }
}

/** The marketing site, a separate deployable (CLAUDE.md §1), and its request form. */
export const LANDING_URL = "https://kapitan-crm.uz";
export const LANDING_LEAD_URL = `${LANDING_URL}/#sorov`;
